// 일일 노트 조회 기록 관리 유틸리티

export interface DailyViewData {
  noteIds: number[];
  date: string;
  count: number;
}

export const getTodayViewedNotes = (): DailyViewData => {
  const today = new Date().toDateString();
  const stored = localStorage.getItem('daily_viewed_notes');
  
  if (!stored) {
    return { noteIds: [], date: today, count: 0 };
  }
  
  try {
    const data = JSON.parse(stored);
    // 날짜가 다르면 초기화
    if (data.date !== today) {
      return { noteIds: [], date: today, count: 0 };
    }
    return data;
  } catch {
    return { noteIds: [], date: today, count: 0 };
  }
};

export const addViewedNote = (noteId: number): void => {
  const today = new Date().toDateString();
  const viewed = getTodayViewedNotes();
  
  if (!viewed.noteIds.includes(noteId)) {
    const updated = {
      noteIds: [...viewed.noteIds, noteId],
      date: today,
      count: viewed.count + 1
    };
    localStorage.setItem('daily_viewed_notes', JSON.stringify(updated));
  }
};

export const isNoteViewedToday = (noteId: number): boolean => {
  const viewed = getTodayViewedNotes();
  return viewed.noteIds.includes(noteId);
};

export const checkDailyLimit = (userInfo: any, currentNoteId: number): { exceeded: boolean, count: number } => {
  const viewed = getTodayViewedNotes();
  const isBasicMember = userInfo?.membership?.currentPlanKey === 'basic';
  const DAILY_LIMIT = 5;
  
  if (!isBasicMember) {
    return { exceeded: false, count: viewed.count };
  }
  
  const wouldExceedLimit = !isNoteViewedToday(currentNoteId) && viewed.count >= DAILY_LIMIT;
  return { exceeded: wouldExceedLimit, count: viewed.count };
};